export const PIE_CHART_COLORS = [
  '#8884d8',
  '#82ca9d',
  '#ffc658',
  '#ff7f50',
  '#00bcd4',
  '#4caf50',
  '#ff9800',
  '#e91e63',
  '#9c27b0',
];

export const MEASUREMENT_POINT_COLORS = {
  bpSystolic: '#ef4444',
  bpDiastolic: '#3b82f6',
  default: '#007bff',
} as const;
